import React, { useState } from 'react';
import { Reveal } from './Reveal';
const faqs = [{
  q: 'Eu não tenho intimidade com tecnologia. Vou conseguir usar?',
  a: 'Conseguir vai. O Aurora foi feito pensando em quem usa o WhatsApp pra trabalhar — e só isso. Cada tela tem 1 ou 2 botões grandes, instruções em português claro e um tour de boas-vindas que te guia em 5 minutos. Se ainda assim você travar, manda mensagem no nosso WhatsApp de suporte. A gente responde como gente, não como robô.'
}, {
  q: 'Preciso instalar alguma coisa no celular?',
  a: 'Não. O Aurora funciona direto no navegador — Chrome, Safari, qualquer um. Você abre, faz login e usa. Pode salvar como atalho na tela inicial pra ficar igual um aplicativo.'
}, {
  q: 'E se eu já tenho minha planilha? Vou perder tudo?',
  a: 'Não vai perder nada. Você cadastra os materiais e produtos no Aurora no seu ritmo — pode começar com 5, depois ir adicionando o resto. E se um dia decidir sair, exporta tudo em CSV (uma planilha) com 1 clique. Você é dona dos seus dados, sempre.'
}, {
  q: 'Quanto tempo até eu ver resultado?',
  a: 'No primeiro produto que você cadastrar com tudo certinho, já vai ver — preto no branco — quanto realmente vai lucrar. Pra muita artesã, esse primeiro número é um choque (no bom sentido).'
}, {
  q: 'Meus dados ficam seguros?',
  a: 'Sim. Cada artesã acessa só os próprios dados, com senha individual. Seus produtos, preços e pedidos são só seus. E você pode exportar tudo em CSV quando quiser.'
}, {
  q: 'E se eu cancelar?',
  a: 'Cancela direto no app, sem ligação, sem retenção, sem pegadinha. E você ainda tem 7 dias depois pra exportar tudo que cadastrou em CSV — pra guardar ou levar pra outro lugar. Aqui não tem armadilha.'
}, {
  q: 'Funciona em iPhone e Android?',
  a: 'Funciona nos dois, e também no computador. Tudo sincronizado — você começa um pedido no celular e termina no notebook, sem perder nada.'
}, {
  q: 'É só pra confeitaria ou serve pra quem faz lembrancinha?',
  a: 'Serve pros dois — e pra qualquer artesã que produz algo com material e tempo. Bolo de aniversário, kit padrinhos, lembrancinha de chá de bebê, brigadeiro fino, decoração de festa, sacolinha personalizada: se você compra material, gasta tempo e vende, o Aurora calcula seu preço.'
}, {
  q: 'Vou ter que cadastrar muita coisa pra começar a usar?',
  a: 'Não. Você pode cadastrar 3 materiais e 1 produto e já ver o app funcionando — em menos de 5 minutos. Daí você vai adicionando o resto enquanto trabalha, no seu ritmo. Não precisa parar a vida pra "organizar tudo" antes de começar.'
}, {
  q: 'Já comprei tanta coisa que não usei. Vai ser igual?',
  a: 'Pergunta justa, e a gente entende a frustração. A diferença é que planilha e e-book são CONTEÚDO — você precisa fazer o trabalho. O Aurora é uma FERRAMENTA — ele faz o cálculo por você. E se em 7 dias você sentir que não é pra você, devolvemos 100% do dinheiro, sem perguntas. O risco é nosso, não seu.'
}];
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="duvidas" className="py-12 md:py-16 px-[5vw] bg-ink" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <Reveal data-id="element-106">
          <div className="text-center mb-16" data-id="element-107">
            <span className="font-caveat text-gold text-2xl block mb-4" data-id="element-108">
              perguntas comuns
            </span>
            <h2 className="font-serif font-bold text-[clamp(34px,5vw,56px)] tracking-[-0.02em] text-white" data-id="element-109">
              <span className="italic text-gold" data-id="element-110">
                O que toda artesã quer saber
              </span>
            </h2>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-111">
          <div className="space-y-4" data-id="element-112">
            {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return <div key={i} className="border-b border-white/10 pb-4" data-id="element-113">
                  <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full flex items-center justify-between text-left py-4 group" data-id="element-114">
                    <span className="font-medium text-[15px] md:text-[16px] text-white pr-8" data-id="element-115">
                      {faq.q}
                    </span>
                    <div className={`w-8 h-8 rounded-full border border-white/20 flex items-center justify-center flex-shrink-0 transition-all duration-300 ${isOpen ? 'bg-gold border-gold text-ink rotate-45' : 'text-white group-hover:border-gold group-hover:text-gold'}`} data-id="element-116">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-117">
                        <line x1="7" y1="0" x2="7" y2="14" data-id="element-118" />
                        <line x1="0" y1="7" x2="14" y2="7" data-id="element-119" />
                      </svg>
                    </div>
                  </button>
                  <div className={`overflow-hidden transition-all duration-400 ease-in-out ${isOpen ? 'max-h-[300px] opacity-100 mb-4' : 'max-h-0 opacity-0'}`} data-id="element-120">
                    <p className="text-[15px] text-white/70 leading-relaxed pr-12" data-id="element-121">
                      {faq.a}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </Reveal>
      </div>
    </section>;
};